export enum PromptCategory {
  DEFAULT = 0,
  CLOTHING = 1,
  WALL = 2,
  SMILE = 3,
  NORMAL = 4,
  PERSONAL_QUALITIES = 5,
}

export const PROMPT_CATEGORY_LABELS = {
  [PromptCategory.DEFAULT]: 'Дефолтный',
  [PromptCategory.CLOTHING]: 'Стиль одежды',
  [PromptCategory.WALL]: 'Стиль стены',
  [PromptCategory.SMILE]: 'Поза (руки, улыбка)',
  [PromptCategory.NORMAL]: 'Обычный',
  [PromptCategory.PERSONAL_QUALITIES]: 'Оценка личных качеств',
} as const;
